import { SystemApi } from '@/modules/core/api/system.api.ts';
import { ErrorUtil } from '@/modules/common/utils/error.util.ts';

export const COMMENT_MARKDOWN_FIELD = 'comment_markdown';

export type CommentWithMarkdown<T extends object> = T & { [COMMENT_MARKDOWN_FIELD]?: string };

function copyItems<T extends object>(items: T[]): CommentWithMarkdown<T>[] {
  return items.map((item) => ({ ...item }));
}

export async function withCommentMarkdown<T extends object>(
  items: T[],
  getCommentId: (item: T) => unknown,
  signal: AbortSignal
): Promise<CommentWithMarkdown<T>[]> {
  const ids = [...new Set(items.map(getCommentId).filter((id): id is number => typeof id === 'number'))];

  try {
    const markdown = await SystemApi.getCommentsMarkdown(ids, signal);

    return items.map((item): CommentWithMarkdown<T> => {
      const id = getCommentId(item);
      const value = typeof id === 'number' ? markdown.get(id) : undefined;

      return value ? { ...item, [COMMENT_MARKDOWN_FIELD]: value } : { ...item };
    });
  } catch (error) {
    if (ErrorUtil.isUnexpected(error)) {
      ErrorUtil.reportError(error);
    }

    return copyItems(items);
  }
}
